// extracted by mini-css-extract-plugin
module.exports = {"bomb":"BombContainer_bomb__RT4Qo","crown-animation":"BombContainer_crown-animation__19M2r","load":"BombContainer_load__3XJnA"};